import React, { useEffect, useState } from "react";
import { FiX, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { Slider } from "rsuite";
import "rsuite/dist/rsuite.css";
import {
  useDispatch,
  useNavigate,
  useSelector,
} from "../../components/hooks/hooks";
import {
  setNoticePeriod,
  setTotalExperience,
  setRelocate,
  setLocation,
  setSkills,
} from "../../redux/reducers/elasticSearchSlice";
import { backendApi } from "../../api/apiService";
import { FaCircleArrowLeft } from "react-icons/fa6";
import { ArrowLeft } from "react-feather";
export default function Filter({ menuClick, closeMenu }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    totalExperience,
    skills,
    location,
    education,
    noticePeriod,
    relocate,
  } = useSelector((state) => state.ElasticSearch);
  const [toggleClass, setToggleClasss] = useState(true);
  const [appliedCount, setAppliedCount] = useState(0);
  const [skillOffset, setSkillOffset] = useState(0);
  const [showNext, setShowNext] = useState(true);
  const [jobSkills, setJobSkills] = useState([]);
  // const [selectedSkills, setSelectedSkills] = useState([])
  const [toggleFilters, setToggleFilters] = useState({
    totalExperiance: true,
    noticePeriod: true,
    relocate: true,
    jobSkill: true,
  });

  useEffect(() => {
    getSkillsList();
  }, []);
  useEffect(() => {
    let applied = 0;
    if (totalExperience > 0) {
      applied += 1;
    }
    if (relocate !== "default") {
      applied += 1;
    }
    if (noticePeriod > 0) {
      applied += 1;
    }
    if (jobSkills.some((job) => job.checked === true)) {
      applied += 1;
    }
    setAppliedCount(applied);
  }, [totalExperience, relocate, noticePeriod, jobSkills]);

  const handleSliderChange = (value, name) => {
    if (name === "totalExperience") {
      dispatch(setTotalExperience(value));
    } else if (name === "noticePeriod") {
      dispatch(setNoticePeriod(value));
    }
  };

  const clearFilters = () => {
    dispatch(setTotalExperience(0));
    dispatch(setRelocate("default"));
    dispatch(setNoticePeriod(0));

    setAppliedCount(0);

    // dispatch(setNoticePeriod(0))
  };
  const checkBoxHandle = (value, name) => {
    let temp;
    if (name === "relocate")
      if (relocate === value) dispatch(setRelocate("default"));
      else dispatch(setRelocate(value));
    if (name === "jobSkill") {
      const updatedJobSkills = jobSkills.map((skill) => {
        // Check if the current skill matches the value being toggled
        if (skill.value === value.value) {
          // If it matches, toggle the checked state
          return { ...skill, checked: !skill.checked };
        }
        // Otherwise, return the skill as is
        return skill;
      });
      setJobSkills(updatedJobSkills);
      dispatch(setSkills(updatedJobSkills));
    }
  };

  const getSkillsList = () => {
    var req = {
      functionName: "skillSetListing",
      siteId: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      const transformedOptions = response.dataSet.map((skill, index) => ({
        value: index + 1,
        label: skill.skill_name,
        active: index <= 9 ? true : false,
        checked: false,
      }));
      setJobSkills(transformedOptions);
    });
  };
  const handleViewNextPreviousTen = (mode) => {
    let tempSkillOffset;
    if (mode === "next") {
      tempSkillOffset = skillOffset + 1;
    } else {
      tempSkillOffset = skillOffset - 1;
    }
    setSkillOffset(tempSkillOffset);
    const indexOfLastPost = tempSkillOffset * 10; // Always start from page 1
    const indexOfFirstPost = indexOfLastPost - 10;
    const currentPosts = jobSkills.map((obj, index) => {
      if (index > indexOfFirstPost && index < indexOfLastPost) {
        return { ...obj, active: true };
      } else {
        return { ...obj, active: false };
      }
    });
    if (indexOfLastPost >= jobSkills.length) {
      setShowNext(false);
    } else {
      setShowNext(true);
    }
    setJobSkills(currentPosts);
  };
  return (
    <div className={`sidenav ${menuClick ? "sidenav-toggle" : ""}`}>
      <div className="sidenav-header">
        <FiX
          style={{
            fontSize: "20px",
            right: "8px",
            top: "8px",
            cursor: "pointer",
          }}
          className="text-secondary opacity-50 position-absolute d-xl-none"
          onClick={() => closeMenu()}
        />
        <a className="navbar-brand m-0" onClick={() => navigate("/dashboard/dashboardMain")}>
          <div className="xilliHeadTop">
            {localStorage.getItem("logo") ? (
              <img
                src={localStorage.getItem("logo")}
                alt="logo"
                width="100"
                height="auto"
                className="img-fluid"
                style={{ marginLeft: "40px" }}
              />
            ) : (
              <></>
            )}
          </div>
        </a>
      </div>
      <hr className="horizontal mt-0"></hr>
      <span className="d-flex align-items-center gap-1 px-4"
        onClick={() => navigate("/dashboard/dashboardMain")}
        style={{ cursor: "pointer", fontSize: "13px" }}
      >
        {/* <FaCircleArrowLeft /> */}
        <ArrowLeft size={14} />
        Go Back
      </span>

      <div className="filter-div">
        <div className="filter-div-head">
          <div className="filter-div-head-left">All Filters</div>
          <div className="filter-div-head-right" onClick={clearFilters}>
            Clear All ({appliedCount})
          </div>
        </div>
        <div className="filter-div-body">
          <div
            className="filter-div-body-head"
            onClick={() =>
              setToggleFilters((prev) => ({
                ...prev,
                totalExperiance: !prev.totalExperiance,
              }))
            }
          >
            Total Experience
            {toggleFilters.totalExperiance ? (
              <FiChevronDown />
            ) : (
              <FiChevronUp />
            )}
          </div>
          <div
            className={`filter-div-body-container ${toggleFilters.totalExperiance ? "" : "active"
              }`}
          >
            <Slider
              defaultValue={1}
              min={0}
              step={1}
              max={20}
              graduated
              progress
              value={totalExperience}
              onChange={(e) => handleSliderChange(e, "totalExperience")}
              renderMark={(mark) => {
                if ([0, 6, 12, 18, 24, 30].includes(mark))
                  return <span>{mark}</span>;
              }}
            />
          </div>
        </div>
        <div className="filter-div-body">
          <div
            className="filter-div-body-head"
            onClick={() =>
              setToggleFilters((prev) => ({
                ...prev,
                noticePeriod: !prev.noticePeriod,
              }))
            }
          >
            Notice Period (Months)
            {toggleFilters.noticePeriod ? <FiChevronDown /> : <FiChevronUp />}
          </div>
          <div
            className={`filter-div-body-container ${toggleFilters.noticePeriod ? "" : "active"
              }`}
          >
            <Slider
              defaultValue={1}
              min={0}
              step={1}
              max={6}
              graduated
              progress
              value={noticePeriod}
              onChange={(e) => handleSliderChange(e, "noticePeriod")}
              renderMark={(mark) => {
                return <span>{mark}</span>;
              }}
            />
          </div>
        </div>
        <div className="filter-div-body">
          <div
            className="filter-div-body-head"
            onClick={() =>
              setToggleFilters((prev) => ({
                ...prev,
                jobSkill: !prev.jobSkill,
              }))
            }
          >
            Skills
            {toggleFilters.jobSkill ? <FiChevronDown /> : <FiChevronUp />}
          </div>
          <div
            className={`filter-div-body-container ${toggleFilters.jobSkill ? "" : "active"
              }`}
          >
            {skillOffset > 1 && (
              <div
                className="custom-view"
                onClick={() => handleViewNextPreviousTen("previous")}
              >
                View Previous
              </div>
            )}
            <div className="custom-checkbox">
              {jobSkills.length > 0 &&
                jobSkills.map((job) => {
                  if (job.active)
                    return (
                      <label className="custom-checkbox-label">
                        <input
                          className="form-check-input m-0"
                          type="checkbox"
                          checked={job.checked}
                          onChange={() => checkBoxHandle(job, "jobSkill")}
                        />
                        <span className="custom-head">{job.label}</span>
                        {/* <span className="custome-counte">(9617)</span> */}
                      </label>
                    );
                })}
              {jobSkills.length > 10 && showNext && (
                <div
                  className="custom-view"
                  onClick={() => handleViewNextPreviousTen("next")}
                >
                  View Next
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="filter-div-body">
          <div
            className="filter-div-body-head"
            onClick={() =>
              setToggleFilters((prev) => ({
                ...prev,
                relocate: !prev.relocate,
              }))
            }
          >
            Willing to Relocate
            {toggleFilters.relocate ? <FiChevronDown /> : <FiChevronUp />}
          </div>
          <div
            className={`filter-div-body-container ${toggleFilters.relocate ? "" : "active"
              }`}
          >
            <div className="custom-checkbox">
              <label className="custom-checkbox-label">
                <input
                  className="form-check-input m-0"
                  type="checkbox"
                  checked={relocate === "yes"}
                  onChange={() => checkBoxHandle("yes", "relocate")}
                />
                <span className="custom-head">Yes</span>
                {/* <span className="custome-counte">(9617)</span> */}
              </label>
              <label className="custom-checkbox-label">
                <input
                  className="form-check-input m-0"
                  type="checkbox"
                  checked={relocate === "no"}
                  onChange={() => checkBoxHandle("no", "relocate")}
                />
                <span className="custom-head">No</span>
                {/* <span className="custome-counte">(9617)</span> */}
              </label>
              {/* <div className="custom-view">View More</div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
